export const createUrl = (endPoint, urlParameters)=>{
    let url = `${endPoint}?`;
    const parametersKeys = Object.keys(urlParameters);
    for (const parameterKey of parametersKeys) {
        if(!urlParameters[parameterKey]) continue;
        url += `&${parameterKey}=${urlParameters[parameterKey]}`
    }
    return url;
}